import { render, staticRenderFns } from "./EventHourglass.vue?vue&type=template&id=f44355ae"
import script from "./EventHourglass.vue?vue&type=script&lang=js"
export * from "./EventHourglass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports